import { render } from "./GunDetailModal.vue?vue&type=template&id=5fc9f794"
import script from "./GunDetailModal.vue?vue&type=script&lang=js"
export * from "./GunDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__